/** @jsx jsx */

/** @jsxFrag React.Fragment */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import Retracked, { useRetracked } from 'js/lib/retracked';

import { Accordion, AccordionHeader, AccordionPanel, Divider } from '@coursera/cds-core';

import Clip from 'bundles/ai-course-coach/components/Conversation/components/Messages/components/ClipRecommendations/Clip';
import type { CreateUserMessageResultFragment } from 'bundles/ai-course-coach/queries/__generated__/aiCoachCreateUserMessageAndReturnResponseMutation';

import _t from 'i18n!nls/learning-assistant-chat-ai';

function ClipRecommendations({
  clips,
  courseId,
}: {
  clips: CreateUserMessageResultFragment['clipRecommendations'];
  courseId?: string;
}) {
  const track = useRetracked();

  if (!clips) {
    return null;
  }

  return (
    <>
      <Divider
        color="dark"
        css={css`
          margin: var(--cds-spacing-100) 0;
        `}
      />
      <Accordion
        variant="silent"
        className="coach-ClipRecommendations"
        onChange={(e, expand_state: boolean) => {
          const expanded_action_tracking = expand_state ? 'expand' : 'collapse';
          track({
            trackingData: {
              timestamp: Date.now(),
            },
            trackingName: `ai_course_coach_chat_clip_recommendation_accordion_${expanded_action_tracking}`,
            action: `click`,
          });
        }}
      >
        <AccordionHeader label={_t('Explore this topic with related video clips')} />
        <AccordionPanel>
          {clips.map((clip) => (
            <Clip {...clip} currentCourseId={courseId} key={clip.itemId} />
          ))}
        </AccordionPanel>
      </Accordion>
    </>
  );
}

export default Retracked.withVisibilityTracking(ClipRecommendations);
